import {
  FindsUsOnAmazon,
  FindsUsOnForbes,
  FindsUsOnSTI,
  FindsUsOnTBA,
  FindsUsOnTOI,
} from 'assets';
import Image from 'next/image';
import React from 'react';

const FindsUsOn = () => {
  const content = [
    {
      image: FindsUsOnTOI,
      alt: 'Times of India',
    },
    {
      image: FindsUsOnAmazon,
      alt: 'Amazon 10 Bestsellers',
    },
    {
      image: FindsUsOnSTI,
      alt: 'Shark Tank India',
    },
    {
      image: FindsUsOnForbes,
      alt: 'Forbes',
    },
    {
      image: FindsUsOnTBA,
      alt: 'Times Business Awards 2024',
    },
  ];

  return (
    <div className='py-10 md:py-14 px-4 md:px-5 lg:px-6 xl:px-12 w-full mx-auto'>
      <h2 className='mb-6 md:mb-8 text-center text-white lg:text-[32px] md:text-2xl text-xl font-semibold tracking-tight'>
        Finds Us On
      </h2>
      <div className='max-w-[1144px] mx-auto rounded-full bg-gradient-to-b from-[#090909] via-[#141414] to-[#262626] border-t border-white/30 shadow-[0_4px_24px_rgba(0,0,0,0.8)] h-[72px] md:h-[100px] px-6 sm:px-12 md:px-[50px] lg:px-[182px] flex items-center justify-between overflow-x-auto no-scrollbar'>
        {content.map((item, index) => (
          <div
            key={index}
            className='flex items-center justify-center shrink-0'
          >
            <Image
              className='w-12 h-12 sm:w-14 sm:h-14 md:w-[90px] md:h-[90px] object-contain transition-transform duration-300 hover:scale-105'
              src={item.image}
              alt={item.alt}
              width={200}
              height={200}
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default FindsUsOn;
